import React, {Component} from 'react';
import { DatePicker } from 'antd';
import moment from 'moment';
import swal from 'sweetalert2';
import {BootstrapTable, TableHeaderColumn, ButtonGroup, ExportCSVButton} from 'react-bootstrap-table';
import { Modal, Row, Col } from 'react-bootstrap';

import "sweetalert2/dist/sweetalert2.min.css";
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';

import AddPayment from '../ManagePayments/AddPayment';

export default class ManageSwayamNGO extends Component {
	constructor(props) {
		super(props);
		this.state = {
			org: null,
			websites: [],
			paymentDetails: null,
			selectedWebsite: null,
			addPaymentFormVisible: false,
			addPaymentLoader: false,
			newPayment: {
				txn_id: '',
				invoice_id: '',
				invoice: null,
				payment_date: null,
				amount: '',
				offer: '',
				is_renewal: false,
				paid_for: '',
				mode: '',
				extras: {
					poc: ''
				}
			},
			instamojo_domestic_api_key: '',
			instamojo_domestic_auth_token: '',
			instamojo_domestic_email: '',
			instamojo_domestic_password: '',
			instamojo_fcra_api_key: '',
			instamojo_fcra_auth_token: '',
			instamojo_fcra_email: '',
			instamojo_fcra_password: '',
			on_trial: false,
			showTxnError: false,
			showInvoiceError: false,
			showInvoiceUrlError: false,
			showDateError: false,
			showAmountError: false,
			showRenewalError: false,
			showPeriodError: false,
			showModeError: false,
			showPOCError: false,
			orgSettingsModalVisible: false,
			editPaymentModalVisible: false
		};
		this.getPaymentDetails = this.getPaymentDetails.bind(this);
	}

	componentDidMount() {
		console.log("inside ms org", this.props);
		fetch(process.env.REACT_APP_API_URL + '/orgs/' + this.props.match.params.orgId + '/websites', {
		  method: 'GET',
		  headers: {
  	    'Auth': this.props.access_token
	  	},
		}).then(function(response) {
		  return response.json();
		}).then(function(data) {
			var websites = data.data.websites;
			for(var i = 0; i < websites.length; i++) {
				if(websites[i]['publishedTill'] === '') websites[i]['publishedTill'] = null;
				else websites[i]['publishedTill'] = moment(websites[i]['publishedTill'], 'DD/MM/YYYY');
				websites[i]['selected'] = false;
			}
			this.setState({
				org: data.data.org,
				websites: data.data.websites,
				instamojo_domestic_api_key: data.data.org.extras.instamojo_domestic_api_key || '',
				instamojo_domestic_auth_token: data.data.org.extras.instamojo_domestic_auth_token || '',
				instamojo_domestic_email: data.data.org.extras.instamojo_domestic_email || '',
				instamojo_domestic_password: data.data.org.extras.instamojo_domestic_password || '',
				instamojo_fcra_api_key: data.data.org.extras.instamojo_fcra_api_key || '',
				instamojo_fcra_auth_token: data.data.org.extras.instamojo_fcra_auth_token || '',
				instamojo_fcra_email: data.data.org.extras.instamojo_fcra_email || '',
				instamojo_fcra_password: data.data.org.extras.instamojo_fcra_password || '',
				on_trial: data.data.org.trial || false
			});
		}.bind(this));
	}

	changePublished(value, index) {
		let websites = this.state.websites;
		websites[index]['isPublished'] = value;
		this.setState({ websites });
	}

	showWebsiteDetails(index) {
		let websites = this.state.websites;
		let prevSelected = websites[index]['selected'];
		for(var i = 0; i < websites.length; i++) {
			websites[i]['selected'] = false;
		}
		if(!prevSelected) {
			websites[index]['selected'] = true;
			this.setState({ selectedWebsite: websites[index]['id'] }, this.getPaymentDetails(websites[index]['id']));
		}
		this.setState({ websites, addPaymentFormVisible: false });
	}

	getPaymentDetails(website_id) {
  	fetch(process.env.REACT_APP_API_URL + '/orgs/' + this.props.match.params.orgId + '/websites/' + website_id + '/payments', {
  	  method: 'GET',
  	  headers: {
  	    'Auth': this.props.access_token
	  	},
  	}).then((response) => response.json())
  	.then((data) => {
  		if(data.status === 'success') {
				this.setState({ paymentDetails: data.data });
		  }
	  });
	}

	changeDate(index, date, dateString) {
		let websites = this.state.websites;
		websites[index]['publishedTill'] = moment(date).format('YYYY-MM-DD');
		this.setState({ websites });
	}

	openPublishedUrl(publishedUrl) {
		if(publishedUrl.startsWith('http')) window.open(publishedUrl, '_blank');
		else window.open('http://' + publishedUrl, '_blank');
	}

	saveWebsite(index) {
		swal({
		  title: 'Are you sure?',
		  text: "You won't be able to revert this!",
		  type: 'warning',
		  showCancelButton: true,
		  confirmButtonText: 'Yes, Save!',
		  cancelButtonText: 'No, Cancel!',
		  confirmButtonClass: 'btn',
		  cancelButtonClass: 'btn',
		}).then(function (result) {
		  if(result.value) {
		  	var website = this.state.websites[index];
		  	var data = {};
		  	data['is_published'] = website['isPublished'];
		  	if(website['publishedTill'] !== null && website['publishedTill'] !== '') data['published_till'] = moment(website['publishedTill']).format('YYYY-MM-DD');
		  	else data['published_till'] = '';
		  	fetch(process.env.REACT_APP_API_URL + '/orgs/' + this.props.match.params.orgId + '/websites/' + website.id, {
		  	  method: 'PUT',
		  	  headers: {
		  	    'Content-Type': 'application/json',
	  	    	'Auth': this.props.access_token
		  	  },
		  	  body: JSON.stringify(data)
		  	}).then((response) => response.json())
		  	.then((data) => {
			  	swal({
			  	  title: "Saved!",
			  	  html: "<h4>Successfully updated Website details!</h4>",
			  	  type: "success"
			  	});
			  });
		  }
		}.bind(this));
	}

	goBack() {
		window.location.pathname = '/manage-swayam';
	}

	showAddPaymentForm() {
		this.setState({ addPaymentFormVisible: true });
	}

	handleChange(name, event) {
		if(name === 'instamojo_domestic_api_key' || name === 'instamojo_domestic_auth_token' || name === 'instamojo_domestic_email' || name === 'instamojo_domestic_password' || name === 'instamojo_fcra_api_key' || name === 'instamojo_fcra_auth_token' || name === 'instamojo_fcra_email' || name === 'instamojo_fcra_password' || name === 'on_trial') {
			if(name === 'on_trial') this.setState({ [name]: !this.state.on_trial });
			else this.setState({ [name]: event.target.value });
		} else {
			let newPayment = this.state.newPayment;
			if(name === 'payment_date') newPayment[name] = event;
			else if(name === 'invoice') newPayment[name] = event.target.files;
			else if(name === 'poc') newPayment['extras']['poc'] = event.target.value;
			else newPayment[name] = event.target.value;
			if(name === 'txn_id') this.setState({ showTxnError: false });
			else if(name === 'invoice') this.setState({ showInvoiceUrlError: false });
			else if(name === 'invoice_id') this.setState({ showInvoiceError: false });
			else if(name === 'payment_date') this.setState({ showDateError: false });
			else if(name === 'amount') this.setState({ showAmountError: false });
			else if(name === 'is_renewal') this.setState({ showRenewalError: false });
			else if(name === 'paid_for') this.setState({ showPeriodError: false });
			else if(name === 'mode') this.setState({ showModeError: false });
			else if(name === 'poc') this.setState({ showPOCError: false });
			this.setState({ newPayment });
		}
	}

	addNewPayment() {
		let newPayment = this.state.newPayment;
		if(newPayment.txn_id !== '' && newPayment.invoice_id !== '' && newPayment.invoice !== null && newPayment.invoice.length && newPayment.payment_date !== null && newPayment.amount !== '' && newPayment.is_renewal !== null && newPayment.paid_for !== '' && newPayment.mode !== '' && newPayment.extras.poc !== '') {
			this.setState({ addPaymentLoader: true });

			let data = new FormData();
			data.append('txn_id', newPayment.txn_id);
			data.append('invoice', newPayment.invoice[0]);
			data.append('invoice_id', newPayment.invoice_id);
			data.append('payment_date', moment(newPayment.payment_date).format('YYYY-MM-DD'));
			data.append('amount', newPayment.amount);
			data.append('offer', newPayment.offer);
			data.append('is_renewal', newPayment.is_renewal);
			data.append('paid_for', newPayment.paid_for);
			data.append('mode', newPayment.mode);
			data.append('extras', JSON.stringify(newPayment.extras));

	  	fetch(process.env.REACT_APP_API_URL + '/orgs/' + this.props.match.params.orgId + '/websites/' + this.state.selectedWebsite + '/payments', {
	  	  method: 'POST',
	  	  headers: {
	  	    'Auth': this.props.access_token
  	  	},
	  	  body: data
	  	}).then((response) => response.json())
	  	.then((data) => {
	  		if(data.status === 'success') {
	  			this.resetAddPaymentForm(this);
			  	swal({
			  	  title: "Saved!",
			  	  html: "<h4>Successfully added new payment!</h4>",
			  	  type: "success"
			  	});
			  	this.getPaymentDetails(this.state.selectedWebsite);
			  }
		  });
	  } else {
	  	if(newPayment.txn_id === '') this.setState({ showTxnError: true });
	  	if(newPayment.invoice === null || !newPayment.invoice.length) this.setState({ showInvoiceUrlError: true });
	  	if(newPayment.invoice_id === '') this.setState({ showInvoiceError: true });
	  	if(newPayment.payment_date === null) this.setState({ showDateError: true });
	  	if(newPayment.amount === '') this.setState({ showAmountError: true });
	  	if(newPayment.is_renewal === null) this.setState({ showRenewalError: true });
	  	if(newPayment.paid_for === '') this.setState({ showPeriodError: true });
	  	if(newPayment.mode === '') this.setState({ showModeError: true });
	  	if(newPayment.extras.poc === '') this.setState({ showPOCError: true });
	  }
	}

	resetAddPaymentForm() {
		this.setState({
			addPaymentFormVisible: false,
			addPaymentLoader: false,
			newPayment: {
				txn_id: '',
				invoice_id: '',
				invoice: null,
				payment_date: null,
				amount: '',
				offer: '',
				is_renewal: false,
				paid_for: '',
				mode: '',
				extras: {
					poc: ''
				}
			},
			showTxnError: false,
			showInvoiceError: false,
			showInvoiceUrlError: false,
			showDateError: false,
			showAmountError: false,
			showRenewalError: false,
			showPeriodError: false,
			showModeError: false,
			showPOCError: false
		});
	}

	showOrgSettingsModal() {
		this.setState({ orgSettingsModalVisible: true });
	}

	hideOrgSettingsModal() {
		this.setState({ orgSettingsModalVisible: false });
	}

	saveOrgSettings() {
		let state = this.state;
		let extras = {};
		extras['instamojo_domestic_api_key'] = state.instamojo_domestic_api_key;
		extras['instamojo_domestic_auth_token'] = state.instamojo_domestic_auth_token;
		extras['instamojo_domestic_email'] = state.instamojo_domestic_email;
		extras['instamojo_domestic_password'] = state.instamojo_domestic_password;
		extras['instamojo_fcra_api_key'] = state.instamojo_fcra_api_key;
		extras['instamojo_fcra_auth_token'] = state.instamojo_fcra_auth_token;
		extras['instamojo_fcra_email'] = state.instamojo_fcra_email;
		extras['instamojo_fcra_password'] = state.instamojo_fcra_password;

  	fetch(process.env.REACT_APP_API_URL + '/orgs/' + this.props.match.params.orgId, {
  	  method: 'PUT',
  	  headers: {
  	    'Content-Type': 'application/json',
        'Auth': this.props.access_token
  	  },
  	  body: JSON.stringify({ extras, on_trial: this.state.on_trial })
  	}).then((response) => response.json())
  	.then((data) => {
  		if(data.status === 'success') {
		  	swal({
		  	  title: "Saved!",
		  	  html: "<h4>Successfully save Organisation Settings!</h4>",
		  	  type: "success"
		  	});
		  	this.hideOrgSettingsModal(this);
		  }
	  });
	}

	isRenewal(cell, row) {
		if(!cell) return 'No';
		else return 'Yes';
	}

	invoiceId(cell, row) {
		if(cell !== null && cell !== '') {
			return (
				<a className="le-link" href={row.invoiceUrl} target="_blank">{cell}</a>
			)
		} else return '';
	}

	editPaymentFormatter(cell, row) {
  	return (
  		<button className="btn edit-payment-button" onClick={this.editPayment.bind(this, row)}><i className="fa fa-pencil"></i></button>
  	)
  }

  pocFormatter(cell, row) {
  	if(row.hasOwnProperty('extras') && row.extras.hasOwnProperty('poc') && row.extras.poc) {
	  	return (
	  		<span>{row.extras.poc}</span>
	  	)
	  } else return '';
  }

  editPayment(payment) {
  	let newPayment = {};
  	newPayment['txn_id'] = payment['txnId'];
  	newPayment['invoice_id'] = payment['invoiceId'] || '';
  	newPayment['invoice_url'] = payment['invoiceUrl'] || '';
  	newPayment['payment_date'] = moment(payment['paymentDate'], 'DD/MM/YYYY');
  	newPayment['amount'] = payment['amount'];
  	newPayment['offer'] = payment['offer'];
  	newPayment['is_renewal'] = payment['isRenewal'];
  	newPayment['paid_for'] = payment['paidFor'];
  	newPayment['mode'] = payment['mode'];
  	newPayment['extras'] = payment['extras'];
  	this.setState({ newPayment, editPaymentModalVisible: true, selected_payment: payment.id });
  }

  hideEditPaymentModal() {
  	this.setState({
  		editPaymentModalVisible: false,
  		addPaymentLoader: false,
  		newPayment: {
  			txn_id: '',
  			invoice_id: '',
  			invoice: null,
  			payment_date: null,
  			amount: '',
  			offer: '',
  			is_renewal: false,
  			paid_for: '',
  			mode: '',
  			extras: {
  				poc: ''
  			}
  		},
  		selected_payment: null,
  		showTxnError: false,
  		showDateError: false,
  		showAmountError: false,
  		showRenewalError: false,
  		showPeriodError: false,
  		showModeError: false,
  		showPOCError: false
  	});
  }

  updatePayment() {
		let newPayment = this.state.newPayment;
		if(newPayment.txn_id !== '' && newPayment.payment_date !== null && newPayment.amount !== '' && newPayment.is_renewal !== null && newPayment.paid_for !== '' && newPayment.mode !== '') {
			this.setState({ addPaymentLoader: true });

			let data = new FormData();
			data.append('txn_id', newPayment.txn_id);
			if(newPayment.invoice !== null && newPayment.invoice !== undefined) data.append('invoice', newPayment.invoice[0]);
			data.append('invoice_id', newPayment.invoice_id);
			data.append('payment_date', moment(newPayment.payment_date).format('YYYY-MM-DD'));
			data.append('amount', newPayment.amount);
			data.append('offer', newPayment.offer);
			data.append('is_renewal', newPayment.is_renewal);
			data.append('paid_for', newPayment.paid_for);
			data.append('mode', newPayment.mode);
			data.append('extras', JSON.stringify(newPayment.extras));

	  	fetch(process.env.REACT_APP_API_URL + '/swayam/payments/' + this.state.selected_payment, {
	  	  method: 'PUT',
	  	  headers: {
	  	    'Auth': this.props.access_token
  	  	},
	  	  body: data
	  	}).then((response) => response.json())
	  	.then((data) => {
	  		if(data.status === 'success') {
	  			this.hideEditPaymentModal(this);
			  	swal({
			  	  title: "Saved!",
			  	  html: "<h4>Successfully added new payment!</h4>",
			  	  type: "success"
			  	});
			  	this.getPaymentDetails(this.state.selectedWebsite);
			  }
		  });
	  } else {
	  	if(newPayment.txn_id === '') this.setState({ showTxnError: true });
	  	if(newPayment.payment_date === null) this.setState({ showDateError: true });
	  	if(newPayment.amount === '') this.setState({ showAmountError: true });
	  	if(newPayment.is_renewal === null) this.setState({ showRenewalError: true });
	  	if(newPayment.paid_for === '') this.setState({ showPeriodError: true });
	  	if(newPayment.mode === '') this.setState({ showModeError: true });
	  	if(newPayment.extras.poc === '') this.setState({ showPOCError: true });
	  }
  }

	render() {
		const paymentTableOptions = {
			// btnGroup: this.createCustomButtonGroup.bind(this),
			// clearSearch: true,
			// onSortChange: this.onSortChange.bind(this),
			// onSearchChange: () => {return null},
			// clearSearchBtn: this.createCustomClearButton.bind(this),
			// exportCSVBtn: this.createCustomExportCSVButton.bind(this),
			// page: this.state.currentPage,
			// onPageChange: this.onPageChange.bind(this),
			// sizePerPage: this.state.sizePerPage,
			sizePerPageList: [
			  { text: '20 Per Page', value: 20 },
			  { text: '50 Per Page', value: 50 },
			  { text: '100 Per Page', value: 100 }
			],
		}

		return (
			<div className="page-container manage-swayam-org-page">
				{this.state.org !== null ? (
					<div className="org-container">
						<div className="org-details" style={this.state.org.coverImage ? {backgroundImage: 'url(' + process.env.REACT_APP_ASSETS_URL + this.state.org.coverImage + ')'} : null}>
							<div className="org-details-left">
								<div className="ngo-logo" style={this.state.org.logo ? {backgroundImage: 'url(' + process.env.REACT_APP_ASSETS_URL + this.state.org.logo + ')'} : null}></div>
								<div className="org-name-container">
									<h2 className="org-name">{this.state.org.name}</h2>
									<h3 className="back-button" onClick={this.goBack.bind(this)}><i className="fa fa-chevron-left"></i> Back</h3>
								</div>
							</div>
							<div className="org-details-right">
								<button className="settings-button" onClick={this.showOrgSettingsModal.bind(this)}><i className="fa fa-cog"></i></button>
							</div>
						</div>
						<div className="select-websites">
							{this.state.websites.map(function(website, index) {
								return (
									<div className={website.selected ? "website-container selected" : "website-container"} key={index}>
										<span className="website-selector-btn" onClick={this.showWebsiteDetails.bind(this, index)}>Website {(index + 1)}</span>
										{website.selected ? (
											<div className="website-details-container">
												<div className="website-settings-container">
													<div className="website-settings">
														<span className="settings-span">{'Is Published : '}</span>
														<div>
															<input type="radio" name="published" checked={website.isPublished}
																onChange={() => this.changePublished(true, index)} /> Yes
														</div>
														<div>
															<input type="radio" name="published" onChange={() => this.changePublished(false, index)}
																checked={!website.isPublished} /> No
														</div>
													</div>

													<div className="website-settings">
														<span className="settings-span">{'Published Till : '}</span>
														<div>
															<DatePicker onChange={this.changeDate.bind(this, index)} format='DD-MM-YYYY'
																defaultValue={website.publishedTill} />
														</div>
													</div>

													<div className="website-settings">
														<span className="settings-span">
															{'Published Url : '}
															<div className={website.isPublished ? "published-url is-published" : "published-url"}
																disabled={!website.isPublished}
																onClick={this.openPublishedUrl.bind(this, website.publishUrl)}>
																{website.publishUrl}
															</div>
														</span>
													</div>

													<div className="website-settings">
														<span className="settings-span">
															{'Sub-Domain Url : '}
															<div className={website.isPublished ? "published-url is-published" : "published-url"}
																disabled={!website.isPublished}
																onClick={this.openPublishedUrl.bind(this, website.subDomainUrl)}>
																{website.subDomainUrl}
															</div>
														</span>
													</div>
												</div>

												<div className="save-website-settings-container">
													<button className="btn btn-success" onClick={this.saveWebsite.bind(this, index)}>Save</button>
												</div>

												{this.state.paymentDetails !== null ? (
													<div className="payment-details-container">
														<div className="payment-details-header">
															<h3>Payment Details</h3>
															<div className="buttons-container">
																<button className="btn btn-success add-payment-button"
																	onClick={this.showAddPaymentForm.bind(this)}>
																	<i className="fa fa-plus"></i> Add Payment
																</button>
															</div>
														</div>

														{this.state.addPaymentFormVisible ? (
															<div className="add-payment-form-container">
																<AddPayment website_id={website.id} newPayment={this.state.newPayment} showModeError={this.state.showModeError}
																	addNewPayment={this.addNewPayment.bind(this)} resetAddPaymentForm={this.resetAddPaymentForm.bind(this)}
																	showInvoiceError={this.state.showInvoiceError} showInvoiceUrlError={this.state.showInvoiceUrlError}
																	showRenewalError={this.state.showRenewalError} showPeriodError={this.state.showPeriodError}
																	showDateError={this.state.showDateError} showAmountError={this.state.showAmountError}
																	showTxnError={this.state.showTxnError} showPOCError={this.state.showPOCError}
																	addPaymentLoader={this.state.addPaymentLoader} handleChange={this.handleChange.bind(this)} />
															</div>
														) : (null)}

														<div className="payment-details-table-container">
															<BootstrapTable data={this.state.paymentDetails} options={paymentTableOptions} className="payment-details-table"
															  striped={false} hover={true} ref='table' csvFileName={this.state.org.name + ' - Payments - ' + String(moment().unix()) + '.csv'} keyField='id'
															  exportCSV search searchPlaceholder="Search by TxnId/InvoiceId/Amount/Date">
															  <TableHeaderColumn dataField="id" 													hidden={true}  export={false} searchable={false}>Id</TableHeaderColumn>
															  <TableHeaderColumn dataField="txnId"				dataSort={true} hidden={false} export={true}  searchable={true}  columnTitle>Transaction Id</TableHeaderColumn>
															  <TableHeaderColumn dataField="invoiceId"    dataSort={true} hidden={false} export={true}  searchable={true}  dataFormat={this.invoiceId}>Invoice Id</TableHeaderColumn>
															  <TableHeaderColumn dataField="invoiceUrl"   dataSort={true} hidden={true}  export={true}  searchable={true}  columnTitle>Invoice Url</TableHeaderColumn>
															  <TableHeaderColumn dataField="paymentDate"  dataSort={true} hidden={false} export={true}  searchable={false} columnTitle>Payment Date</TableHeaderColumn>
															  <TableHeaderColumn dataField="amount"       dataSort={true} hidden={false} export={true}  searchable={true}  columnTitle>Amount</TableHeaderColumn>
															  <TableHeaderColumn dataField="offer"        dataSort={true} hidden={false} export={true}  searchable={false} columnTitle>Offer</TableHeaderColumn>
															  <TableHeaderColumn dataField="isRenewal"    dataSort={true} hidden={false} export={true}  searchable={false} columnTitle dataFormat={this.isRenewal}>Is Renewal</TableHeaderColumn>
															  <TableHeaderColumn dataField="paidFor"      dataSort={true} hidden={false} export={true}  searchable={true}  columnTitle>Payment Period</TableHeaderColumn>
															  <TableHeaderColumn dataField="mode"      		dataSort={true} hidden={false} export={true}  searchable={true}  columnTitle>Mode Of Payment</TableHeaderColumn>
															  <TableHeaderColumn dataField="poc"      	  dataSort={true} hidden={false} export={true}  searchable={true}  dataFormat={this.pocFormatter.bind(this)}>POC</TableHeaderColumn>
															  <TableHeaderColumn dataField="mode"     	  dataSort={false} hidden={false} export={false} searchable={false} width='52px' dataFormat={this.editPaymentFormatter.bind(this)}>Edit</TableHeaderColumn>
															</BootstrapTable>
														</div>
													</div>
												) : (null)}
											</div>
										) : (null)}
									</div>
								)
							}.bind(this))}
						</div>

						{this.state.editPaymentModalVisible && this.state.selectedWebsite !== null ? (
							<Modal className="edit-payment-modal" show={this.state.editPaymentModalVisible}
							  onHide={this.hideEditPaymentModal.bind(this)} bsSize="large">
							  <Modal.Header>
							    <Modal.Title className="modal-header-custom">
							      Edit Payment
							    </Modal.Title>
							  </Modal.Header>
							  <Modal.Body>
							    <Row>
						    		<Col className="edit-payment-container add-payment-form-container" md={12}>
					    				<AddPayment type='edit' website_id={this.state.selectedWebsite} newPayment={this.state.newPayment} showModeError={this.state.showModeError}
					    					addNewPayment={this.updatePayment.bind(this)} resetAddPaymentForm={this.hideEditPaymentModal.bind(this)}
					    					showInvoiceError={this.state.showInvoiceError} showInvoiceUrlError={this.state.showInvoiceUrlError}
					    					showRenewalError={this.state.showRenewalError} showPeriodError={this.state.showPeriodError}
					    					showDateError={this.state.showDateError} showAmountError={this.state.showAmountError}
					    					showTxnError={this.state.showTxnError} showPOCError={this.state.showPOCError}
					    					addPaymentLoader={this.state.addPaymentLoader} handleChange={this.handleChange.bind(this)} />
						    		</Col>
						    	</Row>
						    </Modal.Body>
						  </Modal>
						) : (null)}

						{this.state.orgSettingsModalVisible ? (
							<Modal className="org-settings-modal" show={this.state.orgSettingsModalVisible}
							  onHide={this.hideOrgSettingsModal.bind(this)} bsSize="large">
							  <Modal.Header>
							    <Modal.Title className="modal-header-custom">
							      Organisation Settings
							    </Modal.Title>
							  </Modal.Header>
							  <Modal.Body>
							    <Row>
						    		{/* Extras */}

						    		<Col className="form-elements" md={12}>
							    		<Col className="form-element" md={4}>
							    			<label className="control-label">Instamojo Domestic API key: </label>
							    			<input type="text" className="form-control" id="instamojo_domestic_api_key" name="instamojo_domestic_api_key" value={this.state.instamojo_domestic_api_key}
							    			  placeholder="Instamojo Domestic API key" onChange={this.handleChange.bind(this, 'instamojo_domestic_api_key')} required />
							    		</Col>

							    		<Col className="form-element" md={4}>
							    			<label className="control-label">Instamojo Domestic Auth Token: </label>
							    			<input type="text" className="form-control" id="instamojo_domestic_auth_token" name="instamojo_domestic_auth_token" value={this.state.instamojo_domestic_auth_token}
							    			  placeholder="Instamojo Domestic Auth Token" onChange={this.handleChange.bind(this, 'instamojo_domestic_auth_token')} required />
							    		</Col>

							    		<Col className="form-element" md={4}>
							    			<label className="control-label">Instamojo Domestic Email: </label>
							    			<input type="text" className="form-control" id="instamojo_domestic_email" name="instamojo_domestic_email" value={this.state.instamojo_domestic_email}
							    			  placeholder="Instamojo Domestic Email" onChange={this.handleChange.bind(this, 'instamojo_domestic_email')} required />
							    		</Col>

							    		<Col className="form-element" md={4}>
							    			<label className="control-label">Instamojo Domestic Password: </label>
							    			<input type="text" className="form-control" id="instamojo_domestic_password" name="instamojo_domestic_password" value={this.state.instamojo_domestic_password}
							    			  placeholder="Instamojo Domestic Password" onChange={this.handleChange.bind(this, 'instamojo_domestic_password')} required />
							    		</Col>

							    		<Col className="form-element" md={4}>
							    			<label className="control-label">Instamojo FCRA API key: </label>
							    			<input type="text" className="form-control" id="instamojo_fcra_api_key" name="instamojo_fcra_api_key" value={this.state.instamojo_fcra_api_key}
							    			  placeholder="Instamojo FCRA API key" onChange={this.handleChange.bind(this, 'instamojo_fcra_api_key')} required />
							    		</Col>

							    		<Col className="form-element" md={4}>
							    			<label className="control-label">Instamojo FCRA Auth Token: </label>
							    			<input type="text" className="form-control" id="instamojo_fcra_auth_token" name="instamojo_fcra_auth_token" value={this.state.instamojo_fcra_auth_token}
							    			  placeholder="Instamojo FCRA Auth Token" onChange={this.handleChange.bind(this, 'instamojo_fcra_auth_token')} required />
							    		</Col>

							    		<Col className="form-element" md={4}>
							    			<label className="control-label">Instamojo FCRA Email: </label>
							    			<input type="text" className="form-control" id="instamojo_fcra_email" name="instamojo_fcra_email" value={this.state.instamojo_fcra_email}
							    			  placeholder="Instamojo FCRA Email" onChange={this.handleChange.bind(this, 'instamojo_fcra_email')} required />
							    		</Col>

							    		<Col className="form-element" md={4}>
							    			<label className="control-label">Instamojo FCRA Password: </label>
							    			<input type="text" className="form-control" id="instamojo_fcra_password" name="instamojo_fcra_password" value={this.state.instamojo_fcra_password}
							    			  placeholder="Instamojo FCRA Password" onChange={this.handleChange.bind(this, 'instamojo_fcra_password')} required />
							    		</Col>

							    		<Col className="form-element" md={4}>
							    			<label className="control-label">Organisation On Trial: </label>
							    			<label className="label-container">On Trial
							    			  <input type="checkbox" id="on_trial" name="on_trial" checked={!this.state.on_trial}
							    			  	onChange={this.handleChange.bind(this, 'on_trial')} />
							    			  <span className="checkmark"></span>
							    			</label>
							    		</Col>
							    	</Col>

							    	<Col md={12} className="form-buttons-container">
							    		<button className="btn form-save-button" onClick={this.saveOrgSettings.bind(this)}>Save</button>
							    		<button className="btn form-cancel-button" onClick={this.hideOrgSettingsModal.bind(this)}>Cancel</button>
							    	</Col>
							    </Row>
							  </Modal.Body>
							</Modal>
						) : (null)}
					</div>
				) : (null)}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/ManageSwayam/ManageSwayamORG.js